import gql from "graphql-tag";

const EDIT_ORDER_MUTATION = gql`  
mutation EditOrder($orderData: OrderInput!) {
    editOrder(orderData: $orderData) {
      id
      state
      description
      orderNumber
      addressTo
      fflName
      attention {
          person
          city
          state
          zip
      }
      placedOrderNumber
      eventId
      chapterId
      createdAt
      updatedAt
        address {
            name
            street1
            street2
            city
            region
            postal_code
            country
            phone
        }
      items {
          quantity
          product{ 
                id
                name
                description
                code
                cost
                image{
                    original
                    thumbnail
                    zoom
                }
                maxQty
                stepQty
                startDate
                endDate
                createdAt
                updatedAt
            }
        }
      stakeholders {
          name
          email
          constituentId
          role
          lookupId
      }
    }
}`;

export default EDIT_ORDER_MUTATION;